module.exports = __webpack_public_path__ + "LatoLatin-Bold.86f41d54c4fa52ecfcae.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Bold.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Bold.eot
// module chunks = styles